import StopPaymentPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/StopPaymentPage";
import { BCMSCurrency, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "bcms-react";
import Classes from "model";
import StopPayment from "components/workflows/StopPaymentsWorkflow/classes/StopPayment";

export default function CaptureStopPaymentReasonDD(props) {
    const context = useBCMSContext();
    const { branding } = useModel();
    BCMSRecord.globalControllerFor(Classes, context);
    
    let defaultData = getDefaultPageData(branding.options, context);
    let stopCheckCustomFields = defaultData.payment.stopCheckCustomFields;
    stopCheckCustomFields = StopPayment.setCustomFieldValue(stopCheckCustomFields, "Check Number", "123");
    stopCheckCustomFields = StopPayment.setCustomFieldValue(stopCheckCustomFields, "Check Amount", BCMSCurrency.init(100));

    const data = BCMSStateManagerCRUD.init(defaultData)
    .update([ "payment", "stopCheckCustomFields"], stopCheckCustomFields)
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "reasonDropdown", "isActive" ], true)
    .submit();

    return <StopPaymentPage data={ data } ui={ ui } />
}